import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=2730f04a&scoped=true&"
import script from "./TableBody.vue?vue&type=script&lang=js&"
export * from "./TableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730f04a",
  null
  
)

export default component.exports